import { EventEmitter, Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Injectable({
	providedIn: 'root',
})
export class BreadcrumbService {
	public modalChange: EventEmitter<MenuItem[]> = new EventEmitter<MenuItem[]>();

	public updateItems(modal: MenuItem[]): void {
		if (modal[0]?.routerLink === 'dashboard') {
			modal.splice(0, 1);
		}
		this.modalChange.emit(modal);
	}
}
